<div class="login-page-container">
    <div class="login-container" id=login-container>

        <!-- svg logo -->
        <div class="logo">
            <mat-icon class="logo-icon" [svgIcon]="'license_manager_login'"></mat-icon>
        </div>


        <!-- motto (subtitle) section -->
        <div class="motto is-h6">
            {{ 'confirm_reset_password_title' | translate }}
        </div>

        <form class="login-form-container" [formGroup]="resetPasswordForm" autocomplete="off">
            <mat-form-field appearance="outline" class="mb--10" autocomplete="off">
                <input matInput type="password" class="is-h6" placeholder='{{"password" | translate}}*'
                    formControlName="password" autocomplete="new-password">
            </mat-form-field>
            <mat-form-field appearance="outline" class="mb--10" autocomplete="off">
                <input matInput type='password' class="is-h6" placeholder='{{"confirm_password" | translate}}*'
                    formControlName="confirm_password" autocomplete="new-password">
            </mat-form-field>
            <button mat-flat-button type="submit" color="primary" class="clickable is-button"
                [disabled]="!resetPasswordForm?.valid" (click)="resetPasswordConfirm()">
                <span>{{"save_new_password" | translate | uppercase}}</span>
            </button>
        </form>
    </div>
</div>